import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SendIcon from '@mui/icons-material/Send';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const Container = styled(Grid)({
  padding: '20px'
});

// Info message text
const InfoMsg = styled('div')({
  fontSize: 11,
  fontWeight: 700
});

const SendMsgBox = ({
  onSendMsg,
  onMsgChange,
  message,
  isGeneralConversation
}) => {
  const t = useAutoTranslation();

  return (
    <form>
      <Container container>
        <Grid size={11}>
          <TextField
            id="outlined-basic-email"
            placeholder={t('Type Something...')}
            fullWidth
            onChange={onMsgChange}
            value={message}
          />
        </Grid>
        <Grid align="right" size={1}>
          <Fab
            color="primary"
            aria-label={t('add')}
            onClick={onSendMsg}
            disabled={!message}
            type="submit"
          >
            <SendIcon />
          </Fab>
        </Grid>

        {isGeneralConversation && (
          <InfoMsg>
            {t(
              'Messages you send will be sent to the healthcare provider and may be visible to multiple clinicians.'
            )}
          </InfoMsg>
        )}
      </Container>
    </form>
  );
};

export default SendMsgBox;
